import React from 'react';
import AsyncTerms from './async';
import DefaultBusinessLayout from '../../../../../components/layout/DefaultBusinessLayout';

export default (
  <DefaultBusinessLayout
    key="/business/shopify/privacy"
    exact
    path="/business/shopify/privacy"
    component={AsyncTerms}
    breadcrumb={[
      {
        position: 1,
        name: 'Home',
        item: '/',
      },
      {
        position: 2,
        name: 'Business',
        item: '/business',
      },
      {
        position: 3,
        name: 'Shopify Privacy',
        item: '/business/shopify/privacy',
      },
    ]}
  />
);
